import { render, staticRenderFns } from "./SundryItemAuditStockLogSummary.vue?vue&type=template&id=a4b51a46&lang=true&"
import script from "./SundryItemAuditStockLogSummary.vue?vue&type=script&lang=js&"
export * from "./SundryItemAuditStockLogSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports